import i18n from "src/i18n/config";
import { z } from "zod";

export const requiredMessage = () => i18n.t("common:validation.fieldRequired");

export const requiredText = () => z.string({ error: requiredMessage }).min(1, { error: requiredMessage });

export const toBoolean = (value: unknown) => (value === "true" ? true : value === "false" ? false : undefined);

export const toNumber = (value: unknown) => (typeof value === "string" && value.trim() ? Number(value) : undefined);

export const toList = (value: unknown) =>
    typeof value === "string"
        ? value
              .split(",")
              .map((entry) => entry.trim())
              .filter(Boolean)
        : [];

export const packageName = /^[a-zA-Z][a-zA-Z0-9_]*(\.[a-zA-Z0-9_]+)+$/;

export const invalidPackage = () => i18n.t("common:validation.packageNameInvalid");
